exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n:not(.vertical-collpsed) .navbar-brand-box[data-v-0513b44e] {\n    text-align: left;\n}\n.vertical-collpsed .navbar-brand-box[data-v-0513b44e] {\n    text-align: center;\n    padding: 0;\n}\n", ""]);

// exports
